import { render, staticRenderFns } from "./AccountBank.vue?vue&type=template&id=661b7daa&"
import script from "./AccountBank.vue?vue&type=script&lang=js&"
export * from "./AccountBank.vue?vue&type=script&lang=js&"
import style0 from "./AccountBank.vue?vue&type=style&index=0&id=661b7daa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports